import React from 'react';
import './SearchBar.css';
import binocularsIcon from "../../assets/binoculars.png";

const SearchBar = ({ value, handleSearchKey, clearSearch, formSubmit }) => {
  return (
    <div className="wrapper">
      <form className="searchBar" onSubmit={formSubmit}>
        <input
          id="searchQueryInput"
          type="text"
          name="searchQueryInput"
          placeholder="Find Your Next Adventure..."
          value={value}
          onChange={handleSearchKey}
        />
        <button id="searchQuerySubmit" type="submit" name="searchQuerySubmit">
          <img
            src={binocularsIcon}
            alt="Search"
            style={{ width: '24px', height: '24px' }}
          />
        </button>
      </form>
    </div>
  );
};

export default SearchBar;
